"use client";
import { useZStore } from "@/utils/z-store";
import axios from "axios";
import { useEffect } from "react";
import { initialState } from "@/app/zustand-store/slices/colorSlice";

/**
 * Applies the ACTIVE workspace's brand colours (primary / secondary / metric).
 * Colours are stored per-workspace on the owner, so this re-fetches whenever the
 * active workspace changes — switching workspaces shows that workspace's brand,
 * and a workspace with no custom colours resets to the defaults.
 */
const PrimaryColorUpdater = () => {
  const { data, actions } = useZStore();
  const activeWorkspaceId = data.activeWorkspaceId;

  useEffect(() => {
    let cancelled = false;

    const fetchAccountSettings = async () => {
      try {
        const response = await axios.get(
          "/api/users/update-account-settings",
          // Pin to the active workspace explicitly so a switch can't race the
          // global x-workspace-id header WorkspaceSync sets.
          activeWorkspaceId
            ? { headers: { "x-workspace-id": activeWorkspaceId } }
            : undefined,
        );
        if (cancelled) return;

        const accountSettings = response.data?.accountSettings || {};

        // Apply-only (persist=false): re-applying must not echo a write or
        // overwrite a workspace with defaults. Missing fields fall back to
        // defaults so switching resets rather than carrying colours over.
        actions.setPrimaryColor(
          accountSettings.primaryColor || initialState.primaryColor,
          false,
        );
        actions.setSecondaryColors(
          Array.isArray(accountSettings.secondaryColors) &&
            accountSettings.secondaryColors.length > 0
            ? accountSettings.secondaryColors
            : initialState.secondaryColors,
          false,
        );
        actions.setMetricColors(
          Array.isArray(accountSettings.metricColors) &&
            accountSettings.metricColors.length > 0
            ? accountSettings.metricColors
            : initialState.metricColors,
          false,
        );
      } catch (error) {
        console.error("Error fetching account settings:", error);
      }
    };

    fetchAccountSettings();
    return () => {
      cancelled = true;
    };
  }, [actions, activeWorkspaceId]);

  return null;
};

export default PrimaryColorUpdater;
